<template>
    <div id="year">
        <ul>
            <li class="fl" :class="{active:active == 17}" @click="active=17">
                <h4>充<span>19</span>元</h4>
                <h5>送<span>20</span>元</h5>
                <p>共计3900个书币+书豆</p>
            </li>
            <li class="fr" :class="{active:active == 18}" @click="active=18">
                <h4>充<span>55</span>元</h4>
                <h5>送<span>66</span>元</h5>
                <p>共计12100个书币+书豆</p>
            </li>
            <li class="fl" :class="{active:active == 19}" @click="active=19">
                <h4>充<span>88</span>元</h4>
                <h5>送<span>108</span>元</h5>
                <p>共计19600个书币+书豆</p>
            </li>
            <li class="fr" :class="{active:active == 20}" @click="active=20">
                <h4>充<span>158</span>元</h4>
                <h5>送<span>198</span>元</h5>
                <p>共计35600个书币+书豆</p>
            </li>
        </ul>
        <p class="btn-box">
            <button @click="doRecharge">立即购买</button>
        </p>
        <p class="time">活动时间：1月17日-2月2日</p>
    </div>
</template>

<script>
    export default {
        name: "Year",
        data(){
            return {
                active:17,
            }
        },methods:{
            doRecharge(){
                if(this.active < 17){
                    alert("请选择充值选项！");
                    return;
                }
                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 7,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#year{
    min-height: 1500px;height:100%;background-color: #cf0b00;overflow: auto;background-image: url("../../assets/year/bg.png");background-size: 100% 100%;
    ul{width: 600px;margin: 600px auto;
        li{background-image: url("./../../assets/year/li.png") ;background-repeat:no-repeat;background-size:100%;width: 270px;height: 300px;text-align: center;padding-top: 30px;margin-bottom: 20px;
            h4,h5{font-size: 25px;color: #ffd88e;
                span{font-size: 50px;}
            }
            h4{border-bottom: 1px solid rgba(255,216,142,.2);}
            p{font-size: 25px;padding-top: 60px;color: #ffd88e;}

        }
        li.active{border-bottom: 4px solid #ffd88e;}
    }
    .btn-box{text-align: center;padding: 50px 0;
        button{background: #fcea93;border: none;padding: 10px 40px;font-size: 30px;color: #cf0b00;border-radius: 10px;

        }
    }
    .time{font-size: 25px;text-align: center;color: #ffd88e;}



}
</style>
